import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Reveal } from './Reveal';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-20 sm:py-28" aria-labelledby="faq-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-51" data-mp="1gcxr4mjqn60u">
      <div className="mx-auto max-w-3xl px-6" data-id="element-52" data-mp="2dzeo1qok7hm2">
        <Reveal data-id="element-53" data-mp="2dy3hxk7n5xrs">
          <h2 id="faq-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl" data-id="element-54" data-mp="291mk1yan451i">
            Preguntas frecuentes
          </h2>
        </Reveal>

        <ul className="mt-10 divide-y divide-mint-200 border-y border-mint-200" data-id="element-55" data-mp="240fem5vyzhy0">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} data-id="element-56" data-mp="so68omvya219" data-mpi={index}>
                <h3 data-id="element-57" data-mp="sl0it5fhyw4h">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mint-600" data-id="element-58" data-mp="noa0ebg7zofw">
                    <span className="font-display text-lg leading-snug text-ink sm:text-xl" data-id="element-59" data-mp="fiqfs9jsb0vp">
                      {faq.question}
                    </span>
                    <span className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-mint-700 transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-mint-100' : 'bg-mint-50'}`} aria-hidden="true" data-id="element-60" data-mp="6rge1uylzyfx">
                      <PlusIcon className="h-4 w-4" data-id="element-61" data-mp="3t07v0ak8ps7e" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-62" data-mp="1q0qnw8ylfud">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-63" data-mp="3jz9nhialf2k2">
                      <div className="space-y-3 pb-6 pr-12" data-id="element-64" data-mp="1krb2mnd08bu4">
                        {faq.answer.map(paragraph => <p key={paragraph.slice(0, 24)} className="text-[15px] leading-relaxed text-ink-soft" data-id="element-65" data-mp="1ftjb3ug9urqg">
                            {paragraph}
                          </p>)}
                      </div>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}